module.exports = __webpack_public_path__ + "img/transitions-logo.bce51b93.jpg";